import React from "react";
import Header from "../Components/Common/Header";
import Footer from "../Components/Common/Footer";
import ArticleLinkBox from "../Components/Pages/Article/ArticleLinkBox";

const Article = () => {
  return (
    <>
      <Header label="article" />
      <ArticleLinkBox />
      <Footer label="article" />
    </>
  );
};

export default Article;